/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Api_Errors_Passkey_Verification_FailedInputs */

const nl_auth_api_errors_passkey_verification_failed = /** @type {(inputs: Auth_Api_Errors_Passkey_Verification_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het toevoegen van de passkey is mislukt. Probeer het opnieuw.`)
};

/**

* @param {Auth_Api_Errors_Passkey_Verification_FailedInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_api_errors_passkey_verification_failed = /** @type {((inputs?: Auth_Api_Errors_Passkey_Verification_FailedInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Api_Errors_Passkey_Verification_FailedInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_api_errors_passkey_verification_failed(inputs)
});
export { auth_api_errors_passkey_verification_failed as "auth.api_errors.passkey_verification_failed" }